import { CurrentUserState } from './current-user-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';

import { Action, StateStatus, updateStatus } from './utils/state-manager';

const InitialState: CurrentUserState = {
  // The user starts as null and is populated in the user-provider. There's not
  // many non-authenticated interacts, so typing this as any to appease the typechecks
  // below
  user: null as any,
  userStatus: StateStatus.notAttempted,
  userSharedEmails: [],
  userSharedEmailsStatus: StateStatus.notAttempted,
};

export default (state = InitialState, action: Action) => {
  switch (action.type) {
    case 'REGISTER_USER': {
      return {
        user: action.payload,
        userStatus: StateStatus.success,
      };
    }
    case STARTING('UPDATE_USER'): {
      const { username }: { username: string } = action.payload.args;
      if (username && username === state.user.username) {
        return updateStatus(state, 'user', true);
      }
      return state;
    }
    case SUCCESS('UPDATE_USER'): {
      const { username, user }: { username: string; user: UserRequest } = action.payload.args;
      if (username && username === state.user.username) {
        return updateStatus(state, 'user', false, {
          ...state.user,
          ...user,
          calendarType: state.user.calendarType,
          otherCalendar: state.user.otherCalendar,
        });
      }
      return state;
    }
    case FAILURE('UPDATE_USER'): {
      const { username }: { username: string } = action.payload.args;
      if (username && username === state.user.username) {
        return updateStatus(state, 'user', false);
      }
      return state;
    }
    case SUCCESS('SET_TOKEN'): {
      return { ...state, ...action.payload.data };
    }
    case STARTING('SHARED_EMAILS'): {
      return updateStatus(state, 'userSharedEmails', true);
    }
    case SUCCESS('SHARED_EMAILS'): {
      return updateStatus(state, 'userSharedEmails', false, action.payload.data.emails);
    }
    case FAILURE('SHARED_EMAILS'): {
      return updateStatus(state, 'userSharedEmails', false);
    }
    case SUCCESS('SHARE_APPLICANT'): {
      return {
        ...state,
        userSharedEmailsStatus: {
          dirty: true,
        },
      };
    }
    case STARTING('CALENDAR_PREFERENCES'): {
      return updateStatus(state, 'user', true);
    }
    case SUCCESS('CALENDAR_PREFERENCES'): {
      const {
        username,
        calendarType,
        otherCalendar,
      }: { username: string; calendarType: string | null; otherCalendar: string | null } =
        action.payload.args;

      if (username && username === state.user.username) {
        return updateStatus(state, 'user', false, { ...state.user, calendarType, otherCalendar });
      }
      return state;
    }
    case SUCCESS('CREATE_PAYROLL_SOFTWARE_RESPONSE'): {
      const { data } = action.payload;
      return {
        ...state,
        user: {
          ...state.user,
          PayrollSoftwareResponse: data,
        },
      };
    }
    default:
      return state;
  }
};
